export default "__VITE_ASSET__BDW0NB$N__"